module.exports = __webpack_public_path__ + "img/profileVerified.0ea8a337.png";